
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/parenting-consultation",
      function () {
        return require("private-next-pages/blog/parenting-consultation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/parenting-consultation"])
      });
    }
  